import { defineStore } from 'pinia';
import axios from 'axios';

export const useConsultingStore = defineStore({
  id: 'consulting',
  state() {
    return {
      success: false, //successfully fetch api
      live_report_type: null,
      live_id: null,
      live_report_id: null,
      selectMenu: null,
      selected: null,
      selectedObject: null,
      is_downloading_pdf: false,
      Data: null, //the data from the api
      pagination: {
        currentIndexNumber: null,
        nextIndexPageName: null,
        prevIndexPageName: null,
      },
      currentLogo: null,
      reportTypeLogo: null,
      isFetching: false,
      galleryCount: 0,
    };
  },
  getters: {
    getCurrentLogo() {
      return this.currentLogo;
    },
    getReportTypeLogo() {
      return this.reportTypeLogo;
    },
    getIsFetching() {
      return this.isFetching;
    },
    getGalleryCount() {
      return this.galleryCount;
    },
  },
  actions: {
    setConsultingReportSelectMenu(state, selectMenu) {
      state.selectMenu = selectMenu;
    },
    setConsultingReportData(state, data) {
      state.Data = data;
    },
    async setCurrentLogo(reportTypeId) {
      try {
        this.isFetching = true;
        const { data } = await axios.get(
          `/company-logo/report-type/${reportTypeId}`
        );
        this.reportTypeLogo = data;
        this.currentLogo = data.company_logo;
        this.isFetching = false;
      } catch (err) {
        this.isFetching = false;
      }
    },
    async setGalleryCount(reportTypeId) {
      try {
        const { data } = await axios.get(`/company-logo/count/${reportTypeId}`);
        this.galleryCount = data;
      } catch (err) {
        // TODO: HANDLE ERROR - This is just silencing the error
      }
    },
    async createReportTypeLogo(image, reportTypeId) {
      try {
        const { data } = await axios.post(`/company-logo/report-type`, {
          report_type_id: reportTypeId,
          company_logo_id: image.id,
        });
        this.setReportTypeLogo(data);
      } catch (err) {
        // TODO: HANDLE ERROR - This is just silencing the error
      }
    },
    async updateReportTypeLogo(image, reportTypeId) {
      try {
        const { data } = await axios.put(
          `/company-logo/report-type/${reportTypeId}`,
          {
            company_logo_id: image.id,
          }
        );
        this.setReportTypeLogo(data);
      } catch (err) {
        // TODO: HANDLE ERROR - This is just silencing the error
      }
    },
    setReportTypeLogo(reportTypeLogo) {
      this.reportTypeLogo = reportTypeLogo;
      this.currentLogo = reportTypeLogo.company_logo;
    },
    resetReportTypeLogo() {
      this.reportTypeLogo = null;
      this.currentLogo = null;
    },
  },
});
